import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconTextEdit: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="text-edit, prompts, comment, draft"><path d="M1.75 5.75H9.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M1.75 9.75H6.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M22.75 8.38793L18.6121 4.25L7.75 15.1121V19.25H11.8879L22.75 8.38793Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/></CentralIconBase>;
};

export default IconTextEdit;
